import type {
  IControlSettingData,
  IDynamicControlSetting,
} from '~/presentation/reports/common/type';

import { DEFAULT_FILTER_PRESET } from '~/modules/report-analytic/presets/default-filter';
import { DEFAULT_UI_PRESET } from '~/modules/report-analytic/presets/default-ui';

// const ORDER_LISTING_COLUMNS = [
//   EReportColumnKey.ORDER_ID,
//   EReportColumnKey.ORDER_DATE,
//   EReportColumnKey.TOTAL,
//   EReportColumnKey.VERSION,
//   EReportColumnKey.EXPERIMENT,
//   EReportColumnKey.TRAFFIC_SOURCE,
// ];

export const ORDER_LISTING_DATA_PRESET: IControlSettingData = {
  // [EReportControlId.COLUMN_FILTER]: {
  //   value: ORDER_LISTING_COLUMNS,
  // },
  // [EReportControlId.COLUMN]: {
  //   value: ORDER_LISTING_COLUMNS[0],
  // },
  ...DEFAULT_FILTER_PRESET,
};

export const ORDER_LISTING_UI_PRESET: IDynamicControlSetting = {
  ...DEFAULT_UI_PRESET,
  // [EReportControlId.COLUMN_FILTER]: {
  //   controls: ORDER_LISTING_COLUMNS.map((key) => ORDER_COLUMN_UI[key]),
  // },
};
